import React, { useContext } from "react";

import { Card } from "@churchofjesuschrist/eden-card";
import { spacing64, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import MenuContext from "../../global-layout/top-bar/menu-context";

const borderStyleString = (side, style) => style ? `border-${side}:${style};` : "";

const CenterCard = styled(Card)`
  margin: ${({ isMobile }) => isMobile ? spacing8 : spacing64} auto;
  max-width: 600px;
  width: 100%;
  ${({borderOverride}) => {
  const left = borderStyleString("left", borderOverride?.left);
  const right = borderStyleString("right", borderOverride?.right);
  const top = borderStyleString("top", borderOverride?.top);
  const bottom = borderStyleString("bottom", borderOverride?.bottom);

  return `${top} ${bottom} ${left} ${right}`;
}}
`;

const CenteredCard = ({ children, borderOverride, ...otherProps }) => {
  const { isMobile } = useContext(MenuContext);
  return (
    <CenterCard borderOverride={borderOverride} isMobile={isMobile} {...otherProps}>
      {children}
    </CenterCard>
  );
}

export default CenteredCard;
